import React, { useState } from 'react'
import { GuestListTableContainer } from '../dues.style'
import { AppInputField, AppInputFieldBtn, AppInputFieldSelect, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style';
import { Badge, Button, Spinner, toaster } from 'evergreen-ui';
import { gql, useMutation } from '@apollo/client';
import Cookies from 'js-cookie'
import { formatAmount } from '../../../../../widget/util';
import StopDueButton from './stop_due_btn';

export const UPDATE_DUE = gql`
mutation Due_edit($dueId: ID!, $title: String, $description: String, $startDate: Date, $defaultAmount: Float, $endDate: Date, $paymentFrequency: DuePaymentFrequency, $payerType: DuePayerType) {
  due_edit(dueId: $dueId, title: $title, description: $description, startDate: $startDate, defaultAmount: $defaultAmount, endDate: $endDate, paymentFrequency: $paymentFrequency, payerType: $payerType) {
    code
    error
    success
  }
}
`;

function DueDetailInfoWidget(props) {
  const due_details = props.details

  const [editDue, setEditDue] = useState(false)

  const [updateDue, { loading }] = useMutation(UPDATE_DUE);
 // Function to format date for datetime-local input
 const formatDateForInput = (date) => {
    return new Date(date).toISOString().slice(0, 16);
  };

  const [dataObject, setDataObject] = useState({
    dueId: due_details._id,
    title: due_details.title,
    description: due_details.description,
    startDate: formatDateForInput(due_details.startDate),
    endDate: formatDateForInput(due_details.endDate),
    paymentFrequency: due_details.paymentFrequency,
    payerType: due_details.payerType,
    defaultAmount: parseFloat(due_details.defaultAmount)
  });

  const accesTokenValue = Cookies.get('userAccessToken');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  
    setDataObject({
      ...dataObject,
      [name]: value
    });
  };
  const handleInputChangeAmount = (event) => {
    const { name, value } = event.target;
    setDataObject({
        ...dataObject,
        [name]: parseFloat(value)
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    updateDue({
      variables: dataObject,
      context: {
        headers: {
          Authorization: `Bearer ${accesTokenValue}`,
        },
      },
    })
    .then((response) => {
      toaster.success("Due Updated successfully.")
      window.location.reload()
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }

  return (
    <div>
       {!editDue &&
        <GuestListTableContainer>
            <div className='row'>
                
                <div className='col s12 right'>
                    <div className='right'>
                    { !due_details.isStopped
                    ? 
                        <Button onClick={()=>{
                        setEditDue(true)
                        }}>
                            Edit
                        </Button>
                         :<Badge color="red">Stopped</Badge>
                      }
                    </div>
                </div>
               
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Title</b>
                </div>
                <div className='col s12 m3'>
                    {due_details.title}
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Description</b>
                </div>
                <div className='col s12 m3'>
                    {due_details.description}
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Amount </b>
                </div>
                <div className='col s12 m3'>
                    N{ 
                    formatAmount(parseFloat(due_details.defaultAmount))
                    }
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Payment frequency </b>
                </div>
                <div className='col s12 m3'>
                    {due_details.paymentFrequency==='none'?'Once':due_details.paymentFrequency}
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Who's Paying </b>
                </div>
                <div className='col s12 m3'>
                    {due_details.payerType}
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>Start date </b>
                </div>
                <div className='col s12 m3'>
                    {due_details.startDate}
                </div>
            </div>
            <div className='row'>
                <div className='col s12 m3'>
                    <b>End date </b>
                </div>
                <div className='col s12 m3'>
                    {due_details.endDate}
                </div>
            </div>
            {due_details.isStopped
            ?<p></p>
            :<StopDueButton dueId={due_details.id} />
            }

        </GuestListTableContainer>
        }
        

      {editDue &&
        <form onSubmit={handleSubmit}>
          <div>
            <div className='row'>
              <div className='col s12 m4'>
                <InputFieldTitleText>Title</InputFieldTitleText>
                <AppInputField
                  type="text"
                  value={dataObject.title} // Use dataObject for editable value
                  name="title"
                  onChange={handleInputChange}
                />
              </div>
              <div className='col s12 m4'>
                <InputFieldTitleText>Amount</InputFieldTitleText>
                <AppInputField
                  type="number" step="0.01"
                  value={dataObject.defaultAmount} // Use dataObject for editable value
                  name="defaultAmount"
                  onChange={handleInputChangeAmount}
                />
              </div>
              <div className='col s12  m4'>
                <InputFieldTitleText>Who’s paying</InputFieldTitleText>
                <AppInputFieldSelect
                  name="payerType"
                  value={dataObject.payerType} // Use dataObject for editable value
                  onChange={handleInputChange}
                  className="browser-default" required
                >
                  <option value="" disabled selected>Choose your option</option>
                  <option value="owner">Owners Only</option>
                  <option value="resident_or_owner">Residents Or Owners</option>
                </AppInputFieldSelect>
              </div>
            </div>
            <div className="row">
              <div className='col s12  m4'>
                <InputFieldTitleText>Payment frequency</InputFieldTitleText>
                <AppInputFieldSelect
                  name='paymentFrequency'
                  value={dataObject.paymentFrequency} // Use dataObject for editable value
                  onChange={handleInputChange}
                  className="browser-default" required
                >
                  <option value="" disabled selected>Choose your option</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Yearly">Yearly</option>
                  <option value="None">Once</option>
                </AppInputFieldSelect>
              </div>

              <div className='col s12 m4'>
                <InputFieldTitleText>StartDate</InputFieldTitleText>
                <AppInputField
                  type="datetime-local"
                  name="startDate"
                  value={dataObject.startDate} // Use dataObject for editable value
                  onChange={handleInputChange}
                />
              </div>
              <div className='col s12 m4'>
                <InputFieldTitleText>EndDate</InputFieldTitleText>
                <AppInputField
                  type="datetime-local"
                  name="endDate"
                  value={dataObject.endDate} // Use dataObject for editable value
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col s12 m4'>
                <InputFieldTitleText>Description</InputFieldTitleText>
                <AppInputField
                  type="text"
                  name="description"
                  value={dataObject.description} // Use dataObject for editable value
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="row">
              <div className='col s12 m2'>
                <AppInputFieldBtn
                  type="submit"
                  disabled={loading}
                >
                  {loading && <center><Spinner /></center>}
                  {!loading && 'Save Changes'}
                </AppInputFieldBtn>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  )
}

export default DueDetailInfoWidget;


